var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageDuplicateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.57 16.415a2.709 2.709 0 01-2.705-2.705V7.186H6.75A1.752 1.752 0 005 8.933v8.593a1.752 1.752 0 001.75 1.75h7.957a1.752 1.752 0 001.75-1.75v-1.111zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.003 5.75A1.75 1.75 0 0017.253 4h-6.684a1.75 1.75 0 00-1.75 1.75v7.957a1.75 1.75 0 001.751 1.75h6.684a1.75 1.75 0 001.75-1.75zm0 0"
  })));
}
export default SvgPageDuplicateIcon;